import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const TemplateValues = (props) => {
    const { catchResponse } = useCatchResponse();
    const { onSave, editData, totalOfList, bestOfList } = props;
    const [securityUserID, setSecurityUserID] = useState("");
    const [examTypeList, setExamTypeList] = useState([]);
    const [examType, setExamType] = useState('Individual');
    const [examName, setExamName] = useState('');
    const [examNameErr, setExamNameErr] = useState(false);
    const [examNameErrText, setExamNameErrText] = useState('');
    const [shortName, setShortName] = useState('');
    const [totalMarks, setTotalMarks] = useState('');
    const [minMarks, setMinMarks] = useState('');
    const [minMarksErr, setMinMarksErr] = useState(false);
    const [minMarksErrText, setMinMarksErrText] = useState('');
    const [term, setTerm] = useState([]);
    const [totalValueList, setTotalValueList] = useState([]);
    const [totalValue, setTotalValue] = useState([]);
    const [bestOfValueList, setBestOfValueList] = useState([]);
    const [bestOfValue, setBestOfValue] = useState([]);
    const [termsList, setTermsList] = useState([]);
    const [templateValueId, setTemplateValueId] = useState('');
    const [isOverAllAllow, setIsOverAllAllow] = useState(false);
    const [isPractiseTest, setIsPractiseTest] = useState(false);
    const [reExamType, setReExamType] = useState([]);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        const totalOfData = [{
            Value: '',
            Weightage: ''
        }];
        setSecurityUserID(loginData?._id);
        GetTermsList(loginData?._id);
        GetExamTypeList();

        const mappedTotalList = totalOfList?.map(x => ({
            ...x,
            label: x?.Name,
            value: x?.Name,
        })) || [];

        const mappedBestOfList = bestOfList?.map(x => ({
            ...x,
            label: x?.Name,
            value: x?.Name
        })) || [];

        const totalBestOfList = editData?.IsOverAllAllow ? mappedTotalList : [...mappedBestOfList, ...mappedTotalList];
        setTotalValueList(totalBestOfList);
        setBestOfValueList(mappedBestOfList);

        if (editData) {
            const valueData = totalBestOfList?.filter(x => x?.label !== editData?.Name);
            setTotalValueList(valueData);

            setTemplateValueId(editData?._id);
            setExamType(editData?.ExamType);
            setExamName(editData?.Name);
            setIsOverAllAllow(editData?.IsOverAllAllow);
            setIsPractiseTest(editData?.IsPractiseTest);
            setShortName(editData?.ShortName);
            setTotalMarks(editData?.Marks);
            setMinMarks(editData?.MinMarks);
            setTerm(editData?.Term ? editData?.Term.split(',') : []);
            setBestOfValue(editData?.BestOfValue ? editData?.BestOfValue.split(',') : []);
            setReExamType(editData?.ReExamType ? editData?.ReExamType.split(',') : []);

            const totalValueData = editData?.TotalValue?.map(x => {
                const match = mappedTotalList?.find(z => z?.value === x?.Value);
                return {
                    ...x,
                    MinMarks: match?.MinMarks || '',
                    Marks: match?.Marks || ''
                };
            }) || totalOfData;

            setTotalValue(totalValueData);
        } else {
            setTotalValue(totalOfData);
        }
    }, [editData, totalOfList, bestOfList]);

    const GetExamTypeList = async () => {
        try {
            let data = {
                UserID: securityUserID,
            }
            await api.post(APIConstant.path.getExamTypeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setExamTypeList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTermsList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTermList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTermsList(res?.data?.map(x => ({
                        label: x?.TermName,
                        value: x?._id,
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleOverAllow = (value) => {
        setIsOverAllAllow(value);
        const mappedTotalList = totalOfList?.map(x => ({
            ...x,
            label: x?.Name,
            value: x?.Name,
        })) || [];

        const mappedBestOfList = bestOfList?.map(x => ({
            label: x?.Name,
            value: x?.Name
        })) || [];
        const totalBestOfList = value ? mappedTotalList : [...mappedBestOfList, ...mappedTotalList];
        setTotalValueList(totalBestOfList);
    }

    const handleChange = (e, type) => {
        const value = e.target.value;
        const multiLangValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        if (type === 'ExamName') {
            setExamName(multiLangValue);
        } else if (type === 'ShortName') {
            setShortName(multiLangValue);
        } else if (type === 'TotalMarks') {
            setTotalMarks(numericValue);
            if (minMarks && parseInt(minMarks) >= parseInt(numericValue)) {
                setMinMarks('');
            }
        } else if (type === 'MinMarks') {
            if (parseInt(numericValue) >= parseInt(totalMarks)) {
                setMinMarksErr(true);
                setMinMarksErrText('Min Marks should be less than Total Marks');
                return;
            }
            setMinMarksErr(false);
            setMinMarksErrText('');
            setMinMarks(numericValue);
        }
    };

    const AddTemplateValue = () => {
        if (!CommonConfig.isEmpty(examName)) {
            const termNames = termsList
                .filter(x => term.includes(x?.value))
                .map(x => x.label);
            const totalOfName = totalValue ?
                totalValue?.map(x => x?.Value) : '';
            const weightage = totalValue ?
                totalValue?.map(x => x?.Weightage) : '';
            onSave({
                ExamType: examType,
                Name: examName,
                ShortName: shortName,
                Marks: totalMarks,
                MinMarks: minMarks,
                Term: term ? term.join(',') : '',
                BestOfValue: bestOfValue ? bestOfValue.join(',') : '',
                TermName: termNames.join(', '),
                TotalValue: totalValue || [],
                TotalValueName: totalOfName ? totalOfName.join(', ') : '-',
                Weightage: weightage ? weightage.join(', ') : '-',
                IsOverAllAllow: isOverAllAllow,
                IsPractiseTest: isPractiseTest,
                ReExamType: reExamType ? reExamType.join(',') : '',
            });
        } else {
            setExamNameErr(true);
            setExamNameErrText('Exam is Required');
        }
    };

    const onCancel = () => {
        setExamName('');
        setExamType('');
        setTotalMarks('');
        setShortName('');
        setTerm('');
        setBestOfValue([]);
        setTotalValue([]);
        setTemplateValueId('');
        props.onCancel();
    };

    const totalValueBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div>
                <label htmlFor="totalValue">Total of</label>
                <div className="custom-inputs">
                    <Dropdown
                        id={`Value-${rowIndex}`}
                        value={rowData?.Value}
                        options={totalValueList}
                        onChange={(e) => handleTemplateValuesChange(rowIndex, 'Value', e.value)}
                        placeholder="Select Total"
                        display="chip"
                        className='p-w-100 p-mt-1'
                        filter
                        showClear
                    />
                </div>
            </div>
        )
    };

    const weightageBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div>
                <label htmlFor="Weightage">Weightage</label>
                <div className="custom-inputs">
                    <InputText
                        className="p-w-80 p-mt-1"
                        id={`Weightage-${rowIndex}`}
                        type="text"
                        maxLength={3}
                        placeholder="Weightage"
                        value={rowData?.Weightage}
                        onChange={(e) => handleTemplateValuesChange(rowIndex, 'Weightage', e.target.value)}
                    />
                </div>
            </div>
        )
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-mt-4 p-d-flex p-ai-center">
            {rowIndex === totalValue.length - 1 &&
                <Button
                    icon="pi pi-plus"
                    className="e-sction-btn p-m-0 p-mt-3"
                    onClick={() => addTemplateValue()}
                />}
            {(rowIndex !== 0 || totalValue.length > 1) &&
                <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-mt-3 p-ml-lg-1"
                    onClick={() => removeTemplateValue(rowIndex)}
                />
            }
        </div>
    );

    const addTemplateValue = () => {
        let values = [{
            'Value': '',
            'Weightage': ''
        }];
        setTotalValue([...totalValue, ...values]);
    };

    const removeTemplateValue = (index) => {
        const updatedTemplates = totalValue?.filter((_, i) => i !== index);
        setTotalValue(updatedTemplates);
    };

    const handleTemplateValuesChange = (index, key, value) => {
        const updatedTemplateValues = [...totalValue];
        if (key === 'Value') {
            updatedTemplateValues[index][key] = value;
            const filterdata = totalValueList.filter(x => x?.value === value);
            updatedTemplateValues[index].Marks = filterdata ? filterdata[0]?.Marks : '';
            updatedTemplateValues[index].MinMarks = filterdata ? filterdata[0]?.MinMarks : '';
        } else {
            const numericValue = value.replace(/[^0-9]/g, '');
            updatedTemplateValues[index][key] = numericValue;
        }
        setTotalValue([...updatedTemplateValues]);
    };

    return (
        <div className='p-d-flex flex-column p-jc-between p-h-100'>
            <div className='e-template-value-table'>
                <div className='p-grid'>
                    {examTypeList?.map((tab) => (
                        <div className="p-col-12 p-md-3">
                            <div className="">
                                <RadioButton
                                    inputId={tab?._id}
                                    name={tab?._id}
                                    value={tab?.ExamTypeName}
                                    checked={examType === tab?.ExamTypeName}
                                    onChange={(e) => setExamType(e.value)}
                                    disabled={CommonConfig.isEmpty(templateValueId) ? false : true}
                                />
                                <label htmlFor="Activity" className='p-ml-1'> {tab?.ExamTypeName}</label>
                            </div>
                        </div>
                    ))}
                    {examType === 'Total' && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <div className="custom-inputs">
                                <label htmlFor="isOverAllAllow" className='p-d-block'>Over All Allow</label>
                                <Checkbox
                                    className='p-ml-2 p-mt-1'
                                    inputId="isOverAllAllow"
                                    checked={isOverAllAllow}
                                    onChange={(e) => {
                                        handleOverAllow(e.checked)
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
                    {examType === 'Individual' && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <div className="custom-inputs">
                                <label htmlFor="isPractiseTest" className='p-d-block'>Practise Test</label>
                                <Checkbox
                                    className='p-ml-2 p-mt-1'
                                    inputId="isPractiseTest"
                                    checked={isPractiseTest}
                                    onChange={(e) => setIsPractiseTest(e.checked)}
                                />
                            </div>
                        </div>
                    </div>}
                    {examType !== 'Re-Exam' &&
                        (<>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="examName">ExamName<span style={{ color: "red" }}>*</span></label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="examName"
                                            maxLength={40}
                                            placeholder="ExamName"
                                            value={examName}
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e, 'ExamName')}
                                        />
                                    </FloatLabel>
                                    <span className="error-msg" style={{ color: 'red' }}>
                                        {examNameErr ? examNameErrText : null}
                                    </span>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="shortName">Short Name</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="shortName"
                                            maxLength={20}
                                            placeholder="Short Name"
                                            value={shortName}
                                            onChange={(e) => handleChange(e, 'ShortName')}
                                        />
                                    </FloatLabel>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="totalMarks">Total Marks</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="totalMarks"
                                            maxLength={3}
                                            placeholder="Total Marks"
                                            value={totalMarks}
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e, 'TotalMarks')}
                                        />
                                    </FloatLabel>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="minMarks">Min Marks</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="minMarks"
                                            maxLength={3}
                                            placeholder="Min Marks"
                                            value={minMarks}
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e, 'MinMarks')}
                                        />
                                    </FloatLabel>
                                    <span className="error-msg" style={{ color: 'red' }}>
                                        {minMarksErr ? minMarksErrText : null}
                                    </span>
                                </div>
                            </div>
                        </>)}
                    {(!isOverAllAllow && examType !== 'Re-Exam') && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <label htmlFor="term">Terms</label>
                            <div className="custom-inputs">
                                <MultiSelect
                                    id="term"
                                    value={term}
                                    options={termsList}
                                    onChange={(e) => setTerm(e.value)}
                                    placeholder="Select Terms"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter
                                />
                            </div>
                        </div>
                    </div>}
                    {examType === 'Total' &&
                        <div>
                            <DataTable value={totalValue} responsiveLayout="scroll" key={JSON.stringify(totalValueList)}>
                                <Column header="Total" body={totalValueBodyTemplate} />
                                <Column header="Weightage" body={weightageBodyTemplate} />
                                <Column header="Marks" field='Marks' />
                                <Column header="Min Marks" field='MinMarks' />
                                <Column header="Actions" body={actionsBodyTemplate} />
                            </DataTable>
                        </div>
                    }
                    {examType === 'Best Of' &&
                        <div className="p-col-12 p-md-6 p-pt-2">
                            <div className="custom-inputs">
                                <label htmlFor="bestOfValue">Best Of</label>
                                <div className="custom-inputs">
                                    <MultiSelect
                                        id="bestOfValue"
                                        value={bestOfValue}
                                        options={bestOfValueList}
                                        onChange={(e) => setBestOfValue(e.value)}
                                        placeholder="Select Best Of"
                                        display="chip"
                                        className='p-w-100 p-mt-1'
                                        filter
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {examType === 'Re-Exam' &&
                        <div className="p-col-12 p-md-6 p-pt-2">
                            <div className="custom-inputs">
                                <label htmlFor="reExamValue">Exam type</label>
                                <div className="custom-inputs">
                                    <Dropdown
                                        id='reExam'
                                        value={reExamType}
                                        options={bestOfValueList}
                                        onChange={(e) => setReExamType(e.value)}
                                        placeholder="Select Exam Type"
                                        display="chip"
                                        className='p-w-100 p-mt-1'
                                        filter
                                        showClear
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>

            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-mb-2">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button className='p-m-0 btn-text-action-primary' label="Add" onClick={(e) => AddTemplateValue()} />
            </div>
        </div >
    );
};

export default TemplateValues;
